import React from "react";
import { useSnapshot } from "valtio";
import { voiceAgentStore } from "../../../../../store/voiceAgentStore";

const Blob: React.FC = () => {
  const { speaker, userVolume, status, isBuffering } =
    useSnapshot(voiceAgentStore);

  const getBlobClasses = () => {
    if (status === "idle" || status === "stopped") {
      return "blob-idle";
    }

    if (isBuffering) {
      return "blob-buffering";
    }

    switch (speaker) {
      case "user":
        return "blob-user-speaking";
      case "ai":
        return "blob-ai-speaking";
      default:
        return "blob-idle";
    }
  };

  // Calculate scale dynamically for user speaking
  const scale = speaker === "user" ? 1 + userVolume * 0.3 : 1;

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div
        className={`blob ${getBlobClasses()}`}
        style={{
          transform: `scale(${scale})`,
          transition: "transform 0.1s ease-out",
        }}
      />
    </div>
  );
};

export default Blob;
